export default __webpack_public_path__ + "static/media/up.0791e6a9.png";